import { combineReducers } from 'redux'
import sessionReducer from './session'
import userReducer from './user'
import eventReducer from './event'
import appStateReducer from './appState'
import taskReducer from './tasks'
import inAppNavReducer from '../Components/InAppNav/inAppNavReducer'
import applicationReducer from './application'
import notificationReducer from './notification'
import adminCanidatesReducer from './adminCanidate'
import counterReducer from './counter.js'
//import { reduxer as formreducer } from './redux-form'
import subscriptionsReducer from './subscriptions'
import messagingReducer from './messaging'
import adminUserMgmReducer from './adminUserMgm'
import adminCounterReducer from './adminCounter'
const rootReducer = combineReducers({
  sessionState: sessionReducer,
  userState: userReducer,
  eventState: eventReducer,
  tasksState: taskReducer,
  appState: appStateReducer,
  inAppNavState: inAppNavReducer,
  canidateState: applicationReducer,
  notificationState: notificationReducer,
  subscriptionState: subscriptionsReducer,
  adminCanidateState: adminCanidatesReducer,
  counterState: counterReducer,
  messagingState: messagingReducer,
  adminUserMgm: adminUserMgmReducer,
  adminCounter: adminCounterReducer,

});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js